<script setup>
import { computed } from 'vue';
import { router, usePage } from '@inertiajs/vue3';
import moment from 'moment';
import { useToast } from '@/Composables/useToast';

const { showToast } = useToast();
const page = usePage();

const formattedDeadline = computed(() => {
  const deadline = page.props.emailVerificationDeadline;
  return deadline ? moment(deadline).format('D MMM YYYY, HH:mm') : null;
});

function resendVerification() {
  router.post(
    route('verification.send'),
    {},
    {
      preserveScroll: true,
      onSuccess: () =>
        showToast?.(
          "Verification link sent to your email. Check your spam folder if it doesn't appear in your inbox.",
          'success'
        ),
      onError: () => showToast?.('Unable to send verification link', 'error'),
    }
  );
}
</script>

<template>
  <div
    class="flex flex-col items-start justify-between gap-1 px-3 py-2 mb-2 text-xs text-yellow-800 bg-yellow-100 border border-yellow-300 rounded-lg sm:px-4 sm:py-3 sm:flex-row sm:items-center sm:gap-4 sm:text-sm"
  >
    <span v-if="formattedDeadline">
      {{ $t('Please verify your email by') }} <strong>{{ formattedDeadline }}</strong>
      {{ $t('to keep full access to your account. We sent you a verification link.') }}
    </span>
    <span v-else>
      {{
        $t(
          'Your email is not verified. Some features are restricted until verification is complete.'
        )
      }}
    </span>
    <button
      type="button"
      @click="resendVerification"
      class="inline-flex items-center text-xs font-medium text-yellow-900 underline shrink-0 hover:no-underline sm:text-sm"
    >
      {{ $t('Resend verification email') }}
    </button>
  </div>
</template>
